"use client"

import { Printer } from "lucide-react"

import { Button } from "@/shared/components/ui/button"

import { KULLANIM_KOSULLARI } from "../data/kullanim-kosullari"
import { YasalBelgeSayfasi } from "./yasal-belge-sayfasi"

export function SozlesmeSayfasi() {
  return (
    <YasalBelgeSayfasi
      belge={KULLANIM_KOSULLARI}
      ust={
        <div className="flex flex-col gap-4 rounded-lg border bg-white p-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-1 text-sm">
            <p className="font-medium">Elektronik olarak kabul edilir</p>
            <p className="text-muted-foreground">
              Bu metin kayıt sırasında ve ücretli pakete geçişte onay kutucuğuyla kabul edilir;
              imzalayıp göndermeniz gerekmez. Kabul ettiğiniz sürümün bir nüshası e-posta
              adresinize iletilir.
            </p>
          </div>
          <Button type="button" variant="outline" className="shrink-0" onClick={() => window.print()}>
            <Printer />
            Yazdır / PDF kaydet
          </Button>
        </div>
      }
    />
  )
}
